module.exports = __webpack_public_path__ + "img/bdsh_2.ed417142.png";